import { Suspense } from 'react';
import { Outlet, ScrollRestoration } from 'react-router';
import { useConfig, useSession } from '@/lib/session';
import { Footer } from './Footer';
import { Header, Wordmark } from './Header';
import { cx, Loading } from './ui';

function Banner() {
  const { banner, devNo2fa } = useConfig();
  if (devNo2fa) {
    return (
      <div className="relative z-30 bg-warn/15 px-4 py-2 text-center text-sm font-semibold text-warn">
        Local test mode: two-factor authentication is switched off (DEV_NO_2FA in portal/.env).
      </div>
    );
  }
  if (!banner) return null;
  const tone = { info: 'bg-sp/25 text-info', warn: 'bg-warn/15 text-warn', danger: 'bg-danger/20 text-danger' }[banner.tone];
  return <div className={cx('relative z-30 px-4 py-2 text-center text-sm font-semibold', tone)}>{banner.text}</div>;
}

/** PREVIEW_MODE without the tester cookie: the only page the public sees. */
function ComingSoon() {
  return (
    <div className="relative flex min-h-dvh flex-col items-center justify-center overflow-hidden px-6 text-center">
      <img src="/img/hero.webp" alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" />
      <div className="absolute inset-0 bg-gradient-to-b from-ground/40 via-ground/70 to-ground" />
      <div className="relative">
        <img src="/img/logo-mark.png" alt="" width={96} height={96} className="mx-auto mb-6" />
        <Wordmark className="text-2xl sm:text-3xl" />
        <p className="mt-6 text-lg text-muted">The gates open soon.</p>
      </div>
    </div>
  );
}

export function Layout() {
  const session = useSession();
  const config = useConfig();
  if (session.data && config.preview && !config.previewAllowed) return <ComingSoon />;
  return (
    <div className="relative flex min-h-dvh flex-col">
      <div className="stars" aria-hidden />
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:bg-gold focus:px-4 focus:py-2 focus:text-on-gold">
        Skip to content
      </a>
      <Banner />
      <Header />
      <main id="main" className="relative z-10 flex-1">
        <Suspense fallback={<Loading />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
      <ScrollRestoration />
    </div>
  );
}
